import { Monoid } from "ts-base/monoid";

export type Predicate<T> = (it:T) => boolean;

export namespace Predicate {
	export const always	= <T>():Predicate<T>	=>
		_t	=> true;

	export const never	= <T>():Predicate<T>	=>
		_t	=> false;

	export const not	= <T>(predicate:Predicate<T>):Predicate<T>	=>
		t	=> !predicate(t);

	export const and	= <T>(a:Predicate<T>, b:Predicate<T>):Predicate<T>	=>
		t	=> a(t) && b(t);

	export const or	= <T>(a:Predicate<T>, b:Predicate<T>):Predicate<T>	=>
		t	=> a(t) || b(t);

	export const conjunction	= <T>():Monoid<Predicate<T>>	=> ({
		empty:	always(),
		concat:	and,
	});

	export const disjunction	= <T>():Monoid<Predicate<T>>	=> ({
		empty:	never(),
		concat:	or,
	});

	// aliases for backwards compatibility
	export const andMonoid	= conjunction;
	export const orMonoid	= disjunction;

	// equivalent to arrays.reduce(items)(andMonoid)
	export const every	= <T>(items:ReadonlyArray<Predicate<T>>):Predicate<T>	=>
		t	=> items.every(item => item(t));

	// equivalent to arrays.reduce(items)(orMonoid)
	export const some	= <T>(items:ReadonlyArray<Predicate<T>>):Predicate<T>	=>
		t	=> items.some(item => item(t));

	export const contraMap	= <S, T>(base:Predicate<T>) => (func:(s:S) => T):Predicate<S> =>
		(a:S) => base(func(a));
}
